import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";

@Injectable({ providedIn: "root" })
export class ApiConfigService {
  private readonly base = environment.apiBase;

  /** Survey-definition / creator API base */
  get api(): string {
    return this.base;
  }

  /** Navigation (LOB / Customer / Program / Project) API base */
  get nav(): string {
    return environment.navBase ?? this.base;
  }

  /** Document service API base — used for uploads, downloads, and polling */
  get docApi(): string {
    return environment.documentApiBase ?? this.base;
  }

  /** Alias for docApi — kept for backwards compatibility with existing callers */
  get documentService(): string {
    return this.docApi;
  }

  /** Service-provider UI app base URL — opened in a new tab from the creator UI */
  get serviceProviderApp(): string {
    return environment.serviceProviderAppUrl;
  }

  /**
   * Service-provider-service API base (already includes `/api/v1`). Used by the
   * survey-assignment "Service Providers" tab to list active providers' employees.
   */
  get serviceProviderApi(): string {
    return environment.serviceProviderApiBase;
  }

  /** Collection service API base — used for survey instance exports and responses */
  get collectionApi(): string {
    return environment.collectionApiBase;
  }

  /** Feedback service API base — used by the Report a Bug/Feature form */
  get feedbackApi(): string {
    return environment.feedbackApiBase;
  }

  /** Notification service API base — the Notifications screen (Notification 2.0 rules) */
  get notificationApi(): string {
    return environment.notificationApiBase;
  }

  /** Security service API base — used for the AAD survey-takers roster */
  get securityApi(): string {
    return environment.securityApiBase;
  }
}
